import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { getPersonaApprovalBlockReason } from '../../constants/personas';
import PendingApprovalScreen from './PendingApprovalScreen';

export default function PendingApprovalGate({ children }) {
  const { currentUser, userProfile, profileLoading } = useAuth();

  if (!currentUser) return children;
  if (profileLoading) return null;

  const blockReason = getPersonaApprovalBlockReason(userProfile);
  if (blockReason === 'pending') {
    return <PendingApprovalScreen reason="pending" />;
  }
  if (blockReason === 'rejected') {
    return <PendingApprovalScreen reason="rejected" />;
  }

  return children;
}
